import Vue from 'vue'

export default {
  cloneData: () => original => {
    const data = JSON.parse(JSON.stringify(original))
    const rtn = data instanceof Array ? Object.assign([], data)
      : data instanceof Object ? Object.assign({}, data)
      : data
    return rtn
  },
  makeKey: (state, context) => payload => {
    payload = context.cloneData(payload)
    delete payload.mode
    delete payload.view_mode
    delete payload.period
    return Object.values(payload).join('-')
  },
  getCategories: state => {
    return state.categories
  },
  getCategoriesCnt: (state, context) => {
    return context.getCategories.length
  },
  getActiveCategories (state, context) {
    return context.getCategories.filter(row => row.post_cnt > 0)
  },
  getLatestPosts: (state, context) => {
    return Object.keys(state.latestPosts).length > 0 ? state.latestPosts : context.getPaginationOrigin
  },
  getLatestPostsForHome: (state, context) => {
    return context.getLatestPosts.data.slice(0, 8)
  },
  isLatestPostsFinish: (state, context) => {
    return context.getLatestPosts.total === context.getLatestPosts.data.length
  },
  getPaginationOrigin: (state, context) => {
    return context.cloneData(state.paginationOrigin)
  },
  getCatePosts: (state, context) => {
    const key = `cate_${vm.$route.params.idx}`
    return state.catePosts[key] ? state.catePosts[key] : context.getPaginationOrigin
  },
  isCatePostsFinish: (state, context) => {
    return context.getCatePosts.total === context.getCatePosts.data.length
  },
  getCurrentCate: state => {
    return state.currentCate
  },
  getTagPosts: (state, context) => {
    const key = `tag_${vm.$route.params.tag}`
    return state.tagPosts[key] ? state.tagPosts[key] : context.getPaginationOrigin
  },
  isTagPostsFinish: (state, context) => {
    return context.getTagPosts.total === context.getTagPosts.data.length
  },
  getEditorPosts: (state, context) => {
    const key = `editor_${vm.$route.params.idx}`
    return state.editorPosts[key] ? state.editorPosts[key] : context.getPaginationOrigin
  },
  isEditorPostsFinish: (state, context) => {
    return context.getEditorPosts.total === context.getEditorPosts.data.length
  },
  getCurrentEditor: state => {
    return state.currentEditor
  },
  getSearchArticles: (state, context) => {
    const key = `search_articles_${vm.$route.params.keyword}`
    return state.searchArticles[key] ? state.searchArticles[key] : context.getPaginationOrigin
  },
  isSearchArticlesFinish: (state, context) => {
    return context.getSearchArticles.total === context.getSearchArticles.data.length
  },
  getSearchGalleries: (state, context) => {
    const key = `search_galleries_${vm.$route.params.keyword}`
    return state.searchGalleries[key] ? state.searchGalleries[key] : context.getPaginationOrigin
  },
  isSearchGalleriesFinish: (state, context) => {
    return context.getSearchGalleries.total === context.getSearchGalleries.data.length
  },
  getRegionCountries: state => {
    return state.regionCountries
  },
  getRegionCountriesCnt: (state, context) => {
    return context.getRegionCountries.length
  },
  getBrands: state => {
    return state.brands
  },
  getBrandsCnt: (state, context) => {
    return context.getBrands.length
  },
  getTournaments: (state, context) => {
    const key = context.makeKey(vm.$route.query)
    return state.tournaments[key] ? state.tournaments[key] : context.getPaginationOrigin
  },
  isExistSameKeyTournament: (state, context) => {
    const key = context.makeKey(vm.$route.query)
    return Object.keys(state.tournaments).indexOf(key) > -1
  },
  getUpcomingTournaments: (state) => {
    return state.upcomingTournaments
  },
  isExistUpcomingTournament: (state) => {
    return state.upcomingTournaments.length > 0
  },
  getEvents: (state, context) => {
    const key = context.makeKey(vm.$route.query)
    return state.events[key] ? state.events[key] : context.getPaginationOrigin
  },
  isExistSameKeyEvent: (state, context) => {
    const key = context.makeKey(vm.$route.query)
    return Object.keys(state.events).indexOf(key) > -1
  },
  isExistDatePeriod: (state) => {
    return Object.keys(state.datePeriod).length > 0
  },
  getDatePeriod: (state) => {
    return state.datePeriod
  },
  getFeeds: (state) => {
    return state.feeds
  },
  isExistFeedData: (state) => {
    return state.feeds.length > 0
  },
  getSeries: (state) => {
    return state.series
  },
  isExistSeriesData: (state) => {
    return state.series.length > 0
  },
  getAlbums: (state) => {
    return state.albums
  },
  isExistAlbumData: (state) => {
    return state.albums.length > 0
  },
  getAlbumImages: (state) => {
    return state.albumImages
  },
  isExistAlbumImageData: (state) => {
    return state.albumImages.length > 0
  },

  getDisplayCateData: state => {
    return state.displayCateData
  },
  getDisplayCateDataCnt: state => {
    return state.displayCateData.length
  },
  getDisplayData: state => {
    return state.displayData
  },
  getDisplayPage: state => {
    return state.displayPage
  },
  makeDisplayPagekey: () => page => {
    return page === 'NewsCate' ? `${page}_${vm.$route.params.idx}` : page
  },
  isExistDisplayPage: (state, context) => page => {
    return state.displayPage.includes(context.makeDisplayPagekey(page))
  },
  isExistDisplaySubMiddleBanner: (state, context) => {
    return context.getDisplayData.find(row => row.section.idx === 313)
  },
  isUpdatedDisplayData: state => {
    return state.isUpdatedDisplayData
  },
  getDisplayDataCnt: state => {
    return state.displayData.length
  },
  getDisplayDataFromDB: (state, context) => payload => {
    if (!context.isExistDisplayPage(payload.page)) {
      let params = {params: {
          access: payload.access,
          page: payload.page
      }}
      if (params.params.page === 'NewsCate') params.params.idx = vm.$route.params.idx
      const action = '/displays'
      const key = context.makeDisplayPagekey(payload.page)
      vm.$store.dispatch('setDisplayPage', key).then(() => {
        vm.$axios.get(action, params).then((rs) => {
          vm.$store.dispatch('setDisplayData', rs.data)
        })
      })
    }
  },
  isExistListOfCalledAPI: state => {
    const rtn = api => state.listOfCalledAPI.indexOf(api) > -1
    return rtn
  },
  isToastBannerSmallSize: state => {
    return state.smallToastBanner
  },
  isOpenShareDialog: (state) => {
		return state.openShareDialog
	},
  getCurrentContentsData: state => {
    return state.currentContentsData
  },
  isOpenFooter1Dialog: (state) => {
    return state.openFooter1Dialog
  },
  isOpenFooter2Dialog: (state) => {
    return state.openFooter2Dialog
  },
  isOpenFooter3Dialog: (state) => {
    return state.openFooter3Dialog
  },
  isOpenFaqDialog: (state) => {
    return state.openFaqDialog
  },
  isOpenTeamDialog: (state) => {
    return state.openTeamDialog
  },
  getFroalaAlertText: (state) => {
    return state.froalaAlertText
  }
}
